import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataProcessingService } from './data-prcessing.service';
import { LoggerService } from './logger.service';

import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Card, MonthlyReportItem, NewUserCard, Statistics } from '../interfaces/cards.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CardsService {
  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('card');
  }

  constructor(
    private http: HttpClient,
    private dataProcess: DataProcessingService,
    private loggerService: LoggerService
  ) { }

  getCards(params?: {
    order_by?: string;
    order?: string;
    skip?: number;
    limit?: number;
    [key: string]: any; // for filters
  }): Observable<any> {
    return this.http.get<any>(this.apiUrl, { params: this.dataProcess.fitlerParams(params) });
  }

  orderCardForUser(cardData: NewUserCard): Observable<Card> {
    return this.http.post<Card>(
      `${this.apiUrl}/order-card`, cardData
    );
  }

  checkCardValidity(cardUnique: string): Observable<{ status: string; reason?: string }> {
    return this.http.get<{ status: string; reason?: string }>(
      `${this.apiUrl}/check/${encodeURIComponent(cardUnique)}`
    );
  }

  getCardPdf(card_id: number, card_layout_id = 'default'): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${card_id}/pdf/${card_layout_id}`, { responseType: 'blob' });
  }

  printCardPdf(card_id: number, card_layout_id = 'default'): Observable<any> {
    return this.http.get(`${this.apiUrl}/${card_id}/print_pdf/${card_layout_id}`);
  }

  getCard(id: number): Observable<Card> {
    return this.http.get<Card>(`${this.apiUrl}/${id}`);
  }

  getMonthlyReport(dateFrom: string, dateTo: string): Observable<MonthlyReportItem[]> {
    const params = {
      date_from: dateFrom,
      date_to: dateTo
    };
    return this.http.get<MonthlyReportItem[]>(
      `${this.apiUrl}/month/report`,
      { params }
    );
  }


  getStatistics(dateFrom: string, dateTo: string): Observable<Statistics> {
    const params = {
      date_from: dateFrom,
      date_to: dateTo
    };
    return this.http.get<Statistics>(
      `${this.apiUrl}/statistics`,
      { params }
    );
  }

  changeCardStatus(card_id: number, status: number): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}/change-status`,
      { card_id, status }
    );
  }


  updateCard(id: number, data: Partial<Card>): Observable<Card> {
    return this.http.put<Card>(`${this.apiUrl}/${id}`, data);
  }

  createCard(data: Partial<Card>): Observable<Card> {
    return this.http.post<Card>(this.apiUrl, data);
  }

}
